import { Box, IconButton, Typography } from '@mui/material';
import {
  TEXT_ABOUT_YOUR_SURGERY,
  TEXT_LEARN_PREPARE,
  TEXT_SURGERY_DETAILS,
  // TEXT_PRE_SURGERY_CHECKLIST,
  // IMG_PRE_SURGERY_CHECKLIST,
  // TEXT_PREPARATION_INSTRUCTIONS,
  // IMG_PREPARATION_INSTRUCTIONS,
  // TEXT_LEARN_ABOUT_SURGERY,
  // IMG_EDUCATION_ONLINE_LEARNINGS,
  // TEXT_TESTIMONIALS,
  // TEXT_PATIENTS_SAY,
} from '../../constants';

import { ISurgeryInfoComponentProps } from '../../constants/types';
import { formatDateString } from '../../utils';
import {
  ArrowLeftIcon,
  // ArrowUpRightIcon,
} from '../../components/shared/CustomIcons';
import imgEyeSurgery from '/images/eye-surgery.svg';
// import TaskCapsule from '../../components/shared/TaskCapsule';

const SurgeryInfoComponent: React.FC<ISurgeryInfoComponentProps> = ({
  appointment,
}) => {
  const {
    start_time = '',
    doctor_name = '',
    sub_care_type_name = '',
  } = appointment || {};

  const imgEyeSurgeryStyle = {
    width: '93px',
    height: 'auto',
    right: '24px',
    bottom: '18px',
  };

  return (
    <Box bgcolor="primary.main" className="flex-1">
      <Box
        gap={4}
        pt={8}
        pb={4}
        px={3}
        className="d-flex flex-column align-items-start"
      >
        <IconButton
          aria-label="back"
          sx={{ color: 'common.white', p: 0 }}
          onClick={() => history.back()}
        >
          <ArrowLeftIcon sx={{ fontSize: 40 }} />
        </IconButton>
        <Box sx={{ color: 'common.white' }}>
          <Typography variant="h4" sx={{ mb: 1.5 }}>
            {TEXT_ABOUT_YOUR_SURGERY}
          </Typography>
          <Typography variant="subtitle2" sx={{ opacity: 0.8 }}>
            {TEXT_LEARN_PREPARE}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ gap: '1px', mb: 5 }} className="d-flex flex-column">
        <Box
          sx={{ bgcolor: 'info.main', color: 'common.white', px: 3, py: 5 }}
          className="position-relative fw-semi-bold rounded-50"
        >
          <Typography
            variant="body1"
            sx={{ color: 'paleBlue.main', mb: 1.25 }}
            className="text-uppercase"
          >
            {TEXT_SURGERY_DETAILS}
          </Typography>
          <Box sx={{ gap: 1.5, mb: 6.25 }} className="d-flex flex-column">
            <Typography variant="subtitle1">
              {start_time && formatDateString(start_time, true)}
            </Typography>
            {doctor_name && (
              <Typography variant="subtitle1">{doctor_name}</Typography>
            )}
          </Box>
          <Typography variant="h4" sx={{ maxWidth: '72%' }}>
            {sub_care_type_name}
          </Typography>
          <img
            style={imgEyeSurgeryStyle}
            src={imgEyeSurgery}
            alt="eye surgery"
            className="position-absolute"
          />
        </Box>
        {/* <TaskCapsule
          capsuleHeight={128}
          title={TEXT_PRE_SURGERY_CHECKLIST}
          imgSrc={IMG_PRE_SURGERY_CHECKLIST}
          imgAlt="pre-surgery-checklist"
          imgWidth="159px"
        />
        <TaskCapsule
          capsuleHeight={128}
          title={TEXT_PREPARATION_INSTRUCTIONS}
          imgSrc={IMG_PREPARATION_INSTRUCTIONS}
          imgAlt="preparation-instructions"
          imgWidth="159px"
        />
        <TaskCapsule
          capsuleHeight={128}
          title={TEXT_LEARN_ABOUT_SURGERY}
          imgSrc={IMG_EDUCATION_ONLINE_LEARNINGS}
          imgAlt="learn-about-your-surgery"
          imgWidth="154px"
        /> */}
      </Box>

      {/* <Box
        sx={{ color: 'common.white', gap: 1.5, pb: 4, px: 3 }}
        className="d-flex flex-column"
      >
        <Typography variant="h4">{TEXT_TESTIMONIALS}</Typography>
        <Typography variant="subtitle2" sx={{ opacity: 0.8 }}>
          {TEXT_PATIENTS_SAY}
        </Typography>
      </Box> */}
      {/* <Box
        sx={{ color: 'common.white', gap: '1px', mb: 4 }}
        className="d-flex flex-column"
      >
        <Box
          sx={{ bgcolor: 'info.main', px: 3.5, py: 4 }}
          className="rounded-50"
        >
          <Typography variant="subtitle1" sx={{ mb: 1.5 }}>
            Everything went extremely well. One piece of advice? Prepare a good
            meal to aet after your surgery!
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 300, mb: 2.75 }}>
            Leslie Sutton, Cataract eye surgery with Dr. Patel
          </Typography>
          <Box sx={{ gap: 2 }} className="d-flex align-items-center">
            <Typography
              variant="body1"
              sx={{ fontWeight: 600 }}
              className="text-uppercase"
            >
              Read The Full Story
            </Typography>
            <Box
              sx={{
                width: 48,
                height: 48,
                bgcolor: 'secondary.main',
                color: 'common.white',
                ml: 'auto',
              }}
              className="d-flex justify-content-center align-items-center rounded-circle cursor-pointer"
            >
              <ArrowUpRightIcon />
            </Box>
          </Box>
        </Box>
        <Box
          sx={{ bgcolor: 'info.main', px: 3.5, py: 4 }}
          className="rounded-50"
        >
          <Typography variant="subtitle1" sx={{ mb: 1.5 }}>
            Pain usually goes away in a couple of days. Try listening to
            classical music, it helped me a lot.
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 300, mb: 2.75 }}>
            Casie Hughes, Cataract eye surgery with Dr. Carter
          </Typography>
          <Box sx={{ gap: 2 }} className="d-flex align-items-center">
            <Typography
              variant="body1"
              sx={{ fontWeight: 600, mb: 1.5 }}
              className="text-uppercase"
            >
              Read The Full Story
            </Typography>
            <Box
              sx={{
                width: 48,
                height: 48,
                bgcolor: 'secondary.main',
                color: 'common.white',
                ml: 'auto',
              }}
              className="d-flex justify-content-center align-items-center rounded-circle cursor-pointer"
            >
              <ArrowUpRightIcon />
            </Box>
          </Box>
        </Box>
      </Box> */}
    </Box>
  );
};

export default SurgeryInfoComponent;
